(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["events-summary"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function(){

  const sections = document.querySelectorAll('.shopify-section.events .event');
  const list = document.querySelector('.shopify-section.events-summary .list');

  [].forEach.call(sections, function(section){

    const title = section.getAttribute('data-title');
    const dateLocation = section.getAttribute('data-date-location');

    const item = document.createElement('div');
    item.classList.add('item');

    const link = document.createElement('a');
    link.setAttribute('href', '#');
    link.innerText = title;

    link.addEventListener('click', function(event){
      
      event.preventDefault();

      section.scrollIntoView({
        behavior: 'smooth'
      });

    });

    item.appendChild(link);

    if(dateLocation){
      const extra = document.createElement('span');
      extra.innerText = `${dateLocation}`;
      item.appendChild(extra);
    }
    
    list.appendChild(item);

  });

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
$(function(){

  $('.shopify-section.featured-collection .grid').slick({
    arrows: false,
    variableWidth: true,
    infinite: false,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 1,
          infinite: false
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: '0px',
          infinite: true
        }
      },
      {
        breakpoint: 1,
        settings: {
          slidesToShow: 1,
          // infinite: true
        }
      }
    ]
  });

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    

const burgerButton = document.querySelector('header .header__menu .burger_button');
const bodyElement = document.querySelector('body');

burgerButton.addEventListener('click', () => {

  bodyElement.classList.add('menu-open');

});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nav-large"]) return;
  try {
    

const closeButton = document.querySelector('.nav-large .close');
const bodyElement = document.querySelector('body');

closeButton.addEventListener('click', () => {

  bodyElement.classList.remove('menu-open');

});

const nav = document.querySelector('.nav-large');
const topLevelItems = nav.querySelectorAll('.top-level nav a');
const secondLevels = nav.querySelectorAll('.second-level');

function showSecondLevel(url){

  [].forEach.call(topLevelItems, (topLevelItem) => {

    const itemUrl = topLevelItem.getAttribute('data-url');

    if(itemUrl === url){
      topLevelItem.classList.add('active');
    }else{
      topLevelItem.classList.remove('active');
    }

  });

  [].forEach.call(secondLevels, (secondLevel) => {

    const parentUrl = secondLevel.getAttribute('data-parent-url');

    secondLevel.style.display = parentUrl === url ? '' : 'none';

  });

}

[].forEach.call(topLevelItems, topLevelItem => {

  const url = topLevelItem.getAttribute('data-url');

  topLevelItem.addEventListener('click', event => {

    if(window.innerWidth <= 1024){
      return true;
    }

    if(![].find.call(secondLevels, secondLevel => secondLevel.getAttribute('data-parent-url') === url)){
      return true;
    }

    if(topLevelItem.classList.contains('active')){
      return true;
    }

    event.preventDefault();

    showSecondLevel(url);

  });

});

let initialTopLevelItem = [].find.call(topLevelItems,
  topLevelItem => topLevelItem.getAttribute('data-active') === 'true'
);

if( !initialTopLevelItem ){
  initialTopLevelItem = topLevelItems[0];
}

showSecondLevel( initialTopLevelItem.getAttribute('data-url') );

// Record scrollbar width
const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
document.documentElement.style.setProperty('--scrollbar-width', `${scrollbarWidth}px`);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["similar-products"]) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }
        
        $('.shopify-section.featured-collection .grid').slick({
          arrows: false,
          variableWidth: true,
          infinite: false,
          responsive: [
            {
              breakpoint: 1025,
              settings: {
                slidesToShow: 1,
                infinite: false
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
                centerMode: true,
                centerPadding: '0px',
                infinite: true
              }
            },
            {
              breakpoint: 1,
              settings: {
                slidesToShow: 1,
                // infinite: true
              }
            }
          ]
        });

      })
      .catch(e => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

  observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video"] && !Shopify.designMode) return;
  try {
    

  [].forEach.call(document.querySelectorAll('.shopify-section.video'), section => {

    const videoContainer = section.querySelector('.video');
    const video = videoContainer.querySelector('video');

    if(!video){
      return false;
    }

    const playButton = section.querySelector('.play-button');

    videoContainer.addEventListener('click', () => {

      if(video.paused){
        
        playButton.classList.add('hidden');
        video.setAttribute('controls', '');
        video.play();

      }else{

        video.pause();
        video.removeAttribute('controls');
        playButton.classList.remove('hidden');

      }

    });

  });


  } catch(e) { console.error(e); }
})();
})();
